/**
 * When the Judge.me preview badge is clicked, scroll to the review widget.
 * If the widget lives inside an accordion, open it first.
 */
(function judgemeReviewsAccordion() {
  const REVIEW_TARGET_SELECTOR =
    '.jdgm-rev-widg, #judgeme_product_reviews, [id*="judge_me_reviews_review"], [id*="judge-me-reviews"][id*="review_widget"]';
  const PREVIEW_BADGE_SELECTOR =
    '.jdgm-preview-badge, .jdgm-prev-badge, [id*="judge_me_reviews_preview"], [id*="judge-me-reviews"][id*="preview_badge"]';
  const SCROLL_OFFSET = 100;
  const ACCORDION_OPEN_DELAY_MS = 250;

  /** @returns {HTMLElement | null} */
  function findReviewsTarget() {
    const target = document.querySelector(REVIEW_TARGET_SELECTOR);
    return target instanceof HTMLElement ? target : null;
  }

  /**
   * @param {HTMLElement} target
   * @returns {boolean} Whether the accordion was closed before opening
   */
  function openContainingAccordion(target) {
    const accordion = target.closest('accordion-custom');
    if (!(accordion instanceof HTMLElement)) return false;

    const details = accordion.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) return false;

    const wasClosed = !details.open;
    details.open = true;

    return wasClosed;
  }

  /** @param {HTMLElement} target */
  function scrollToTarget(target) {
    const top = target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth',
    });
  }

  /** @returns {boolean} Whether navigation was handled */
  function revealAndScrollToReviews() {
    const target = findReviewsTarget();
    if (!target) return false;

    const wasClosed = openContainingAccordion(target);
    const delay = wasClosed ? ACCORDION_OPEN_DELAY_MS : 0;

    window.setTimeout(() => scrollToTarget(target), delay);

    return true;
  }

  /** @param {Event} event */
  function handleJudgemeNavigation(event) {
    if (!(event.target instanceof Element)) return;

    const isPreviewBadge = event.target.closest(PREVIEW_BADGE_SELECTOR);
    const isReviewAnchor = event.target.closest('a[href*="#judgeme"]');

    if (!isPreviewBadge && !isReviewAnchor) return;
    if (!revealAndScrollToReviews()) return;

    event.preventDefault();
    event.stopPropagation();
  }

  function handleHashNavigation() {
    if (!location.hash.includes('judgeme')) return;

    revealAndScrollToReviews();
  }

  function init() {
    document.addEventListener('click', handleJudgemeNavigation, true);
    handleHashNavigation();
    window.addEventListener('hashchange', handleHashNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
